export enum MacType {
  MacIntel = 'macIntel',
  AppleSilicon = 'appleSilicon',
}
